/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Many from './Many/index'
import No from './No/index'
import One from './One/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/PatientsList/Filters/MedicalHistoryQuestions/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let medicalHistoriesQuestionsValueData = fromData.useDataFormat({ viewPath,
context: 'medical_histories_questions',
format: fromFormat.getOneOrManyView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: medicalHistoriesQuestionsValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'One'}>
<One
  viewPath={`${viewPath}/One`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Many'}>
<Many
  viewPath={`${viewPath}/Many`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}